import { render, staticRenderFns } from "./HealthDetails.vue?vue&type=template&id=7599d3e0"
import script from "./HealthDetails.vue?vue&type=script&lang=js"
export * from "./HealthDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports